import { JSX } from 'react'

import { IconProps } from '../../icon'

const Comment: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M24 10C15.1713 10 8 15.7108 8 22.7179C8 25.4092 9.08308 28.0513 11.0687 30.2174L9.96923 35.7149C9.82154 36.4697 10.1005 37.2246 10.6913 37.7169C11.0687 38.0123 11.5282 38.1764 11.9877 38.1764C12.2667 38.1764 12.5292 38.1272 12.7918 38.0123L19.8154 35.0092C21.1774 35.3046 22.5887 35.4523 24 35.4523C32.8287 35.4523 40 29.7415 40 22.7344C40 15.7272 32.8287 10 24 10ZM24 32.9744C22.6215 32.9744 21.2759 32.8267 19.9795 32.5149C19.7169 32.4492 19.4544 32.4821 19.2082 32.5805L12.5456 35.4359L13.6123 30.0697C13.6944 29.6595 13.5631 29.2492 13.2677 28.9538C11.4297 27.1487 10.4615 24.9826 10.4615 22.7179C10.4615 17.0564 16.5333 12.4615 24 12.4615C31.4667 12.4615 37.5385 17.0564 37.5385 22.7179C37.5385 28.3795 31.4667 32.9744 24 32.9744Z'
      fill='black'
    />
  </svg>
)

export default Comment
